import React from 'react';
import { IconDelegateBoost16 } from './DelegateBoost16';
import { IconDelegateBoost24 } from './DelegateBoost24';
import { IconDelegateBoost32 } from './DelegateBoost32';
export var IconDelegateBoost = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? 'currentColor' : _c;
    switch (size.toString()) {
        case '16':
            return React.createElement(IconDelegateBoost16, { color: color });
        case '24':
            return React.createElement(IconDelegateBoost24, { color: color });
        case '32':
            return React.createElement(IconDelegateBoost32, { color: color });
        default:
            return React.createElement(IconDelegateBoost24, { size: size, color: color });
    }
};
